import {FC} from 'react'
import {Category, CategoryStatus} from '../../core/_models'

type Props = {
  category: Category
}

const CategoryStatusCell: FC<Props> = ({category}) => {
  let look: string = 'light-primary'
  switch (category.status_name) {
    case CategoryStatus.active.value:
      look = 'light-success'
      break
    case CategoryStatus.inactive.value:
      look = 'light-secondary text-dark'
      break
    case CategoryStatus.draft.value:
      look = 'light-danger'
      break
  }

  return (
    <>
      {category && (
        <div className={`badge badge-${look} fw-bolder`}>
          {category.status_name.charAt(0).toUpperCase() + category.status_name.slice(1)}
        </div>
      )}
    </>
  )
}

export {CategoryStatusCell}
